// constants/propertyType.ts
export const propertyTypeOption = [
  { value: "1", name: "آپارتمان" },
  { value: "2", name: "خانه و ویلا" },
  { value: "3", name: "دفتر کار، دفاتر اداری و مطب" },
  { value: "4", name: "مغازه و غرفه" },
  { value: "5", name: "دفاتر صنعتی، کشاورزی و تجاری" },
  { value: "6", name: "زمین و ملک کلنگی" },
];
